"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Circle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
function Circle({ size = 40, color = "primary" }) {
    return ((0, jsx_runtime_1.jsx)("div", { style: {
            width: size,
            height: size,
            borderRadius: "50%",
            backgroundColor: color,
            transition: "all 0.2s"
        }, className: `bg-${color}` }));
}
exports.Circle = Circle;
